import React, { Fragment } from 'react'
import { Section } from '../../components'
import { map } from 'lodash'
export const funcRenderLink = linkBreadcrumbs => {
  return {
    renderCompanyprofile: () => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.companyProfile}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderUserManagementBuyer: () => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.userManagement}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderUserDetail: () => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.userManagement}
                  {v.createUser}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderUserEditForm: () => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.userManagement}
                  {v.editUser}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderSupplierManagementBuyer: () => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.supplierManagement}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderUploadSupplier: () => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.supplierManagement}
                  {v.uploadSupplier}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderSupplierManagementEdit: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.supplierManagement}
                  {v.editSupplier && v.editSupplier(url)}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderSupplierDiscovery: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.supplierDiscovery && v.supplierDiscovery(url)}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderSupplierInformation: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.supplierDiscovery &&
                    v.supplierDiscovery('/supplier-discovery')}
                  {v.supplierInformation && v.supplierInformation()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderRiskManagement: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.riskManagement && v.riskManagement()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderUploadRegulatory: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.regulatory && v.regulatory()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderSustainaBility: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.sustainaBility && v.sustainaBility()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderComprehensiveAssessment: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.comprehensiveAssessment && v.comprehensiveAssessment()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderSourcingProjects: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.sourcingProjects && v.sourcingProjects()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderCreateEvent: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.sourcingProjects &&
                    v.sourcingProjects(url.urlSourcingProjects)}
                  {v.createEvent && v.createEvent()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderSourcingEvent: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.sourcingProjects &&
                    v.sourcingProjects(url.urlSourcingProjects)}
                  {v.sourcingEvent && v.sourcingEvent()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderSourcingEventEdit: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.sourcingProjects &&
                    v.sourcingProjects(url.urlSourcingProjects)}
                  {v.sourcingEvent && v.sourcingEvent(url.urlSourcingEvent)}
                  {v.sourcingEventEdit && v.sourcingEventEdit()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderSourcingEventsEdit: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.sourcingProjects &&
                    v.sourcingProjects(url.urlSourcingProjects)}
                  {v.sourcingProjectDetail &&
                    v.sourcingProjectDetail(url.urlProjectDetails)}
                  {v.sourcingEventsEdit && v.sourcingEventsEdit()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderSourcingProjectDetail: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.sourcingProjects &&
                    v.sourcingProjects(url.urlSourcingProjects)}
                  {v.sourcingProjectDetail && v.sourcingProjectDetail()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderCreateNewRound: url => {
      const isFrom = localStorage.getItem('isFromDetail')
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.sourcingProjects &&
                    v.sourcingProjects(url.urlSourcingProjects)}
                  {isFrom.includes('true') &&
                    v.sourcingProjectDetail &&
                    v.sourcingProjectDetail(url.urlProjectDetails)}
                  {isFrom === 'false' &&
                    v.sourcingEvent &&
                    v.sourcingEvent(url.urlSourcingEvent)}
                  {v.sourcingCreateNewRound && v.sourcingCreateNewRound()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderSourcingDetailFormEdit: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.sourcingProjects &&
                    v.sourcingProjects(url.urlSourcingProjects)}
                  {v.sourcingProjectDetail &&
                    v.sourcingProjectDetail(url.urlProjectDetails)}
                  {v.sourcingDetailFormEdit && v.sourcingDetailFormEdit()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderCompareEvents: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.sourcingProjects &&
                    v.sourcingProjects(url.urlSourcingProjects)}
                  {v.sourcingProjectDetail &&
                    v.sourcingProjectDetail(url.urlProjectDetails)}
                  {v.sourcingCompareEvents && v.sourcingCompareEvents()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
    renderCompareEvent: url => {
      return (
        <Fragment>
          <Section
            id="page_breadcrumb_buyer_management"
            className="breadcrumbs"
          >
            {map(linkBreadcrumbs, (v, k) => {
              return (
                <Fragment key={k}>
                  {v.home}
                  {v.sourcingEvent && v.sourcingEvent(url.urlSourcingEvent)}
                  {v.sourcingCompareEvent && v.sourcingCompareEvent()}
                </Fragment>
              )
            })}
          </Section>
        </Fragment>
      )
    },
  }
}
